export default "__VITE_ASSET__DcyhaHaA__"